import React from 'react';
import { TFunction } from 'react-i18next';
import {
  Link,
  Card,
} from '@piwikpro/ui-components';
import { ProductAnalytics } from '@piwikpro/product-analytics';

const PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES = {
  DRUPAL: '@platform/command/appInstallation/drupal',
  INSTAPAGE: '@platform/command/appInstallation/instapage',
  SQUARESPACE: '@platform/command/appInstallation/squarespace',
  WIX: '@platform/command/appInstallation/wix',
  NO_PIWIK_TAG_MANAGER: '@platform/command/appInstallation/noPiwikTagManager',
};

interface OtherMethodsInstallProps {
  productAnalytics: ProductAnalytics
  t: TFunction
}

const OtherMethodsInstall: React.FC<OtherMethodsInstallProps> = ({
  productAnalytics,
  t,
}) => (
  <Card>
    <Card.Section subdued padding="narrow">
      <Link
        onClick={() => productAnalytics.push({
          type: PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.DRUPAL,
        })}
        size="medium"
        href="https://help.piwik.pro/support/getting-started/drupal-install-a-container-with-a-tracking-code/"
      >
        {t('apps.details.installation.other-methods.option-drupal')}
      </Link>
    </Card.Section>
    <Card.Section subdued padding="narrow">
      <Link
        onClick={() => productAnalytics.push({
          type: PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.INSTAPAGE,
        })}
        size="medium"
        href="https://help.piwik.pro/support/getting-started/instapage-install-a-container-with-a-tracking-code/"
      >
        {t('apps.details.installation.other-methods.option-instapage')}
      </Link>
    </Card.Section>
    <Card.Section subdued padding="narrow">
      <Link
        onClick={() => productAnalytics.push({
          type: PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.SQUARESPACE,
        })}
        size="medium"
        href="https://help.piwik.pro/support/getting-started/squarespace-install-a-container-with-a-tracking-code/"
      >
        {t('apps.details.installation.other-methods.option-squarespace')}
      </Link>
    </Card.Section>
    <Card.Section subdued padding="narrow">
      <Link
        onClick={() => productAnalytics.push({
          type: PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.WIX,
        })}
        size="medium"
        href="https://help.piwik.pro/support/getting-started/wix-install-a-container-with-tracking-code/"
      >
        {t('apps.details.installation.other-methods.option-wix')}
      </Link>
    </Card.Section>
    <Card.Section subdued padding="narrow">
      <Link
        onClick={() => productAnalytics.push({
          type: PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.NO_PIWIK_TAG_MANAGER,
        })}
        size="medium"
        href="https://help.piwik.pro/support/getting-started/no-piwik-pro-tag-manager-install-a-tracking-code/"
      >
        {t('apps.details.installation.other-methods.option-no-piwik-tag-manager')}
      </Link>
    </Card.Section>
  </Card>
);

export default OtherMethodsInstall;
